export const FILTER_CONFIG = {
  requestId: { type: 'string' as const },
  clientId: { type: 'string' as const },
  email: { type: 'string' as const },
  fullName: { type: 'string' as const },

  createdAtFrom: { type: 'string' as const },
  createdAtTo: { type: 'string' as const },

  status: { type: 'array' as const, default: ['new'] },
  documentType: { type: 'array' as const },
  products: { type: 'array' as const },
  country: { type: 'array' as const },
  manager: { type: 'array' as const },

  hasDeposit: { type: 'boolean' as const },
  isDuplicate: { type: 'boolean' as const },
  isPremium: { type: 'boolean' as const },

  page: { type: 'string' as const, default: '1', pagination: true },
  pageSize: { type: 'string' as const, default: '10', pagination: true },
  sortField: { type: 'string' as const, default: 'id', pagination: true },
  sortOrder: { type: 'string' as const, default: 'descend', pagination: true },
}

export const FLOW_FILTER_CONFIG = {
  status: { type: 'array' as const, default: ['new'] },
  country: { type: 'array' as const },
  hasDeposit: { type: 'boolean' as const },
  isDuplicate: { type: 'boolean' as const },
}

export const FLOW_FILTER_KEYS = ['status', 'country', 'hasDeposit', 'isDuplicate'] as const

export const DOCUMENT_TYPE_OPTIONS = [
  { label: 'verification', value: 'verification' },
  { label: 'profile change', value: 'profile_change' },
  { label: 'updating document', value: 'updating_document' },
]

export const STATUS_OPTIONS = [
  { label: 'New', value: 'new' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Rejected', value: 'rejected' },
]

export const PRODUCT_OPTIONS = [
  { label: 'Headway', value: 'headway' },
  { label: 'Nova', value: 'nova' },
]
